<template>
    <multiselect
        v-model="value"
        placeholder="Seleccionar temporada"
        label="nombre"
        track-by="id"
        :options="listas"
        :multiple="false"
        v-on:select="(selectedOpt) => $emit('selected', selectedOpt)"
        :allowEmpty="false"
    />
</template>

<script>
export default {
    props: ['value'],
    computed: {
        listas() {
            return this.$store.getters.getListas;
        }
    }
}
</script>